<ion-card class="ion-padding" *ngIf="error" [routerLink]="['/bones/test-tools/core/error/detail', error.id]">
  <ion-card-title color="danger">
    <span>Error</span>
    <ion-icon name="open" class="ion-float-right"></ion-icon>
  </ion-card-title>
  <ion-item>
    <ion-label>{{ error.message || 'Error' }}</ion-label>
  </ion-item>
</ion-card>
